module.exports = __webpack_public_path__ + "static/iascone-da4f4e3e904a941ef4e7756ddc1fcb03.jpg";